/** Normalize read aliases to the current wire values used by requests and analytics. */
export function normalizeSubscriptionTier(tier) {
    switch (tier) {
        case 'basic':
        case 'viewer':
            return 'viewer';
        case 'pro':
        case 'max':
            return tier;
        default:
            return undefined;
    }
}
// TODO(ENT-6348): Drop this projection after Enterprise API writers and clients
// have cut over. Consumer session values remain outside this migration.
export function normalizeEnterpriseAccountTier(orgUuid, tier) {
    return orgUuid && orgUuid !== 'none' && tier === 'basic' ? 'viewer' : tier;
}
export function normalizeEnterpriseSession(session) {
    const user = session?.user;
    if (session && user) {
        const tier = normalizeEnterpriseAccountTier(user.org_uuid, user.subscription_tier);
        if (tier !== user.subscription_tier) {
            return { ...session, user: { ...user, subscription_tier: tier } };
        }
    }
    return session;
}
//# sourceMappingURL=subscriptionTier.js.map